import { Add } from "@mui/icons-material";
import { Button, Grid } from "@mui/material";
import { Control, Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import {
  TalentCertificate,
  TalentCertificateDocument,
} from "../../../talents/talentAPI";
import WorkPermitDocumentList from "./WorkPermitDocumentList";
import { useEffect } from "react";

type Props = {
  certificate?: TalentCertificate;
  control: Control<any, any>;
  handleRemoveExistingDocuments: (
    filename: string,
    id: string,
    version: number,
  ) => void;
  name: string;
  showUploadButton?: boolean;
  handleEditDocument?: (document: TalentCertificateDocument | File) => void;
};

const WorkPermitDocuments = ({
  certificate,
  control,
  handleRemoveExistingDocuments,
  name,
  showUploadButton = true,
  handleEditDocument,
}: Props) => {
  const { t } = useTranslation();
  const { resetField } = useFormContext();

  const handleRemoveDocument = (document: TalentCertificateDocument) => {
    if (document) {
      const filename = document.filename;
      const id = certificate?.id as string;
      const version = certificate?.version as number;

      handleRemoveExistingDocuments(filename, id, version);
    }
  };

  useEffect(() => {
    resetField(name, { defaultValue: certificate?.documents });
  }, [certificate?.documents, resetField, name]);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <>
          {showUploadButton && (
            <Grid item xs={8}>
              <WorkPermitDocumentList
                documents={value}
                onChange={onChange}
                handleRemoveDocument={handleRemoveDocument}
                handleEditDocument={handleEditDocument}
              />
              <Button
                sx={{
                  height: "30px",
                  textTransform: "none",
                  borderRadius: "15px",
                  fontWeight: "700",
                }}
                variant="outlined"
                startIcon={<Add />}
                component="label"
              >
                <input
                  type="file"
                  accept={[".jpg", ".jpeg", ".pdf"].toString()}
                  hidden
                  onChange={(event) => {
                    const files = event.target.files;
                    if (files && files.length) onChange([...value, files[0]]);
                  }}
                />
                {t("common:addFile")}
              </Button>
            </Grid>
          )}
        </>
      )}
    />
  );
};

export default WorkPermitDocuments;
